import React, { PureComponent, Fragment } from 'react';
import Observer from '@researchgate/react-intersection-observer';

const bottomStyles = {
  position: 'absolute',
  width: 1,
  height: 1,
  bottom: 1,
  left: 0,
  visibility: 'hidden',
};

export default (threshold, root = null) => WrappedComponent => {
  const displayName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';

  return class WithIntersectionObserver extends PureComponent {
    static displayName = `withIntersectionObserver(${displayName})`;

    state = {
      isIntersecting: true,
      isBottom: false,
    };

    handleChangeTop = ({ isIntersecting, intersectionRatio }) => {
      this.setState({
        isIntersecting: isIntersecting && intersectionRatio >= threshold,
      });
    };

    handleChangeBottom = ({ isIntersecting, intersectionRatio }) => {
      this.setState({
        isBottom: isIntersecting && intersectionRatio >= threshold,
      });
    };

    render() {
      return (
        <Fragment>
          <Observer
            onChange={this.handleChangeTop}
            threshold={threshold}
            root={root}
          >
            <div style={{ height: 1 }} />
          </Observer>
          <WrappedComponent
            {...this.props}
            isIntersecting={this.state.isIntersecting}
            isBottom={this.state.isBottom}
          />
          <Observer
            onChange={this.handleChangeBottom}
            threshold={threshold}
            root={root}
            rootMargin="0% 0% 25%"
          >
            <div style={bottomStyles} />
          </Observer>
        </Fragment>
      );
    }
  };
};
